const Layout = ({ children }) => {
  return <>{children}</>;
};

export default Layout;
